// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("UserChallengeProgress", {
  id: __t.u64(),
  userId: __t.u64(),
  challengeId: __t.u64(),
  currentValue: __t.u32(),
  completed: __t.bool(),
  claimed: __t.bool(),
});


